import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// External components
import AddressSchedulePicker from "@/components/addressSchedulePicker/addressSchedulePicker";
import ModalAddress from "@/components/modalAddressHome/modalAddress";

// Helpers
import { subcriptionCreationWeekDayToSpanish } from "@/plugins/subscriptions_helper";
import { getCityZoneByCityZoneId } from "@/plugins/address_helper";
import {
  getNextDeliveryDateByCreationWeekDay,
  getWeekDayByCreationWeekDayNumber,
  getAvailableSchedulesByCityZone,
} from "@/plugins/schedules_helper";
import moment from "moment";

@Component({
  components: { AddressSchedulePicker, ModalAddress },
  methods: {
    subcriptionCreationWeekDayToSpanish,
    getNextDeliveryDateByCreationWeekDay,
    moment,
    getWeekDayByCreationWeekDayNumber,
  },
})
export default class EditSubscriptionAddressSchedule extends Vue {
  @Getter getSubscription;
  @Getter getUser;
  @Getter getCity;

  @Action action_updateSubscription;

  @Mutation SPINNER;

  isEditingAddressSchedule = false;
  isShowingAddressModal = false;

  selectedAddress = null;
  selectedCreationWeekDay = null;
  selectedProgramSchedule = null;
  currentCityZone = null;

  extendedProgramSchedule = "5:30 PM - 8:00 PM";

  get getAvailableSchedules() {
    return getAvailableSchedulesByCityZone(
      this.currentCityZone,
      this.selectedCreationWeekDay,
      this.extendedProgramSchedule
    );
  }

  mounted() {
    this.setInitialData();
  }

  findAddressByAddressId(addressId) {
    return this.getUser.addresses.find((address) => address.id === addressId);
  }

  async updateSubscriptionAddressSchedule() {
    const payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
      subscription: {
        subscription: {
          creation_week_day: this.selectedCreationWeekDay.creation_week_day,
          program_schedule: this.selectedProgramSchedule,
          address_id: this.selectedAddress.id,
        },
      },
    };
    try {
      this.SPINNER(true);
      await this.action_updateSubscription(payload);
      this.isEditingAddressSchedule = false;
      this.setInitialData();
      this.SPINNER(false);
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al intentar actualizar la suscripción. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
  }

  setInitialData() {
    const { address_id, creation_week_day, program_schedule } = this.getSubscription;
    this.onSelectAddress(this.findAddressByAddressId(address_id));
    this.selectedCreationWeekDay = getWeekDayByCreationWeekDayNumber(creation_week_day);
    this.selectedProgramSchedule = program_schedule;
    this.isEditingAddressSchedule = false;
  }

  onSelectAddress(newAddress: any) {
    this.selectedAddress = newAddress;
    this.currentCityZone = getCityZoneByCityZoneId(this.getCity, newAddress.zone_id);
  }

  @Watch("selectedCreationWeekDay")
  onCreationWeekDayChange() {
    if (
      this.selectedCreationWeekDay.creation_week_day !== 1 &&
      this.selectedProgramSchedule === this.extendedProgramSchedule
    ) {
      this.selectedProgramSchedule = this.getAvailableSchedules[0];
    }
  }
}
